import {ObjectModelPropertyChildType, ObjectModelPropertyName, ObjectModelPropertyRootType, ObjectModelPropertyType} from "~/enums/objectModelPropertyType"
import assertNever from "../../../global/assetNever";
import {IConfirmModalConfig} from '~/interfaces/modalInterfaces'
import {IObjectModelBuiltinPropertyDetail, ObjectModelBuiltinCategory, ObjectModelBuiltinPropertyDetails, ObjectModelBuiltinPropertyType} from "~/enums/objectModelBuiltinPropertyType"
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {ObjectModelRelationType} from "~/enums/objectModelRelationType";
import {EnumHelper} from "~/helpers/enumHelper";
import {AccessPermission} from '~/enums/accessPermission'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'
import {IObjectModelProperty} from '~/interfaces/objectModelInterfaces'
import {InputFormatType} from '../../../formability/form_builder/models/inputFormatType'

export type BuiltInTypesSetNumber = 1 | 2 | 3

export default class ObjectModelPropertyDefinition {
  static getComponent(propertyType: ObjectModelPropertyType) {
    switch (propertyType) {
      case ObjectModelPropertyRootType.Text:
        return 'short-text';
      case ObjectModelPropertyRootType.LongText:
        return 'long-text';
      case ObjectModelPropertyRootType.PickList:
        return "pick-list";
      case ObjectModelPropertyRootType.Number:
        return "number";
      case ObjectModelPropertyRootType.DateTime:
        return "date-time";
      case ObjectModelPropertyRootType.MappedProperty:
        return "mapped-property";
      case ObjectModelPropertyRootType.RelationshipCount:
        return "relationship-count";
      case ObjectModelPropertyRootType.DerivedField:
        return "derived-field";
      case ObjectModelPropertyChildType.PickListOption:
        return;
      case ObjectModelPropertyRootType.AutoIncrement:
        return "auto-increment";
      case ObjectModelPropertyRootType.FileAttachment:
        return "file-attachment";
      case ObjectModelPropertyRootType.Aggregate:
        return "aggregate";
      case ObjectModelPropertyRootType.Section:
        return;
      default:
        assertNever(propertyType);
    }
  }

  static getDisplayName(propertyType: ObjectModelPropertyType) {
    switch (propertyType) {
      case ObjectModelPropertyRootType.Text:
        return 'Short Text';
      case ObjectModelPropertyRootType.LongText:
        return 'Long Text';
      case ObjectModelPropertyRootType.PickList:
        return "Pick List";
      case ObjectModelPropertyRootType.Number:
        return "Number";
      case ObjectModelPropertyRootType.DateTime:
        return "Date/Time";
      case ObjectModelPropertyRootType.MappedProperty:
        return "Mapped Property";
      case ObjectModelPropertyRootType.RelationshipCount:
        return "Relationship Count";
      case ObjectModelPropertyRootType.DerivedField:
        return "Derived Field";
      case ObjectModelPropertyChildType.PickListOption:
        return "Pick List Option";
      case ObjectModelPropertyRootType.AutoIncrement:
        return "Auto-Increment";
      case ObjectModelPropertyRootType.FileAttachment:
        return "File Attachment";
      case ObjectModelPropertyRootType.Aggregate:
        return "Aggregate";
      case ObjectModelPropertyRootType.Section:
        return "Section";
      default:
        assertNever(propertyType);
    }
  }

  static getIcon(propertyType: ObjectModelPropertyType) {
    switch (propertyType) {
      case ObjectModelPropertyRootType.Text:
        return 'text';
      case ObjectModelPropertyRootType.LongText:
        return 'long-text';
      case ObjectModelPropertyRootType.PickList:
        return "picklist";
      case ObjectModelPropertyRootType.Number:
        return "numbers";
      case ObjectModelPropertyRootType.DateTime:
        return "datepicker";
      case ObjectModelPropertyRootType.MappedProperty:
        return "mapped-property";
      case ObjectModelPropertyRootType.RelationshipCount:
        return "relationship-count";
      case ObjectModelPropertyRootType.DerivedField:
        return "florin";
      case ObjectModelPropertyChildType.PickListOption:
        return;
      case ObjectModelPropertyRootType.AutoIncrement:
        return "relationship-count";
      case ObjectModelPropertyRootType.FileAttachment:
        return "upload";
      case ObjectModelPropertyRootType.Aggregate:
        return "florin";
      case ObjectModelPropertyRootType.Section:
        return "section";
      default:
        assertNever(propertyType);
    }
  }

  static getComponentClass(propertyType: ObjectModelPropertyType) {
    return `builder-element element-${ObjectModelPropertyDefinition.getComponent(propertyType)} omp-${ObjectModelPropertyDefinition.getComponent(propertyType)}`;
  }

  static getControlGroups(): { name: string, icon: string, type: ObjectModelPropertyRootType }[] {
    return [
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.Text),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.Text),
        type: ObjectModelPropertyRootType.Text
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.LongText),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.LongText),
        type: ObjectModelPropertyRootType.LongText
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.PickList),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.PickList),
        type: ObjectModelPropertyRootType.PickList
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.Number),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.Number),
        type: ObjectModelPropertyRootType.Number
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.DateTime),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.DateTime),
        type: ObjectModelPropertyRootType.DateTime
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.MappedProperty),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.MappedProperty),
        type: ObjectModelPropertyRootType.MappedProperty
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.RelationshipCount),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.RelationshipCount),
        type: ObjectModelPropertyRootType.RelationshipCount
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.DerivedField),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.DerivedField),
        type: ObjectModelPropertyRootType.DerivedField
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.AutoIncrement),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.AutoIncrement),
        type: ObjectModelPropertyRootType.AutoIncrement
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.FileAttachment),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.FileAttachment),
        type: ObjectModelPropertyRootType.FileAttachment
      },
      {
        name: ObjectModelPropertyDefinition.getDisplayName(ObjectModelPropertyRootType.Aggregate),
        icon: ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.Aggregate),
        type: ObjectModelPropertyRootType.Aggregate
      },
    ];
  }

  static changeWarningConfig(): Partial<IConfirmModalConfig> {
    return {
      affirmButtonClass: 'green block',
      affirmText: 'Yes',
      cancelButtonClass: 'red outline block',
      confirmationMessage: 'If you publish these changes, data for this property will be erased when you publish the model. Are you sure you want to proceed?',
    }
  }

  /**
   * This is a place to store common sets of built in property types used throughout the application
   * If you ever add/remove to/from a set, please check the change is appropriate for all locations
   * it is being used.
   * If it is not, then it's probably best to make a new set. Please describe the set and its intended uses.
   *
   * To add a new set, change the setNumber typing to include that number
   *   ex: if "setNumber: 1" then add a new set by "setNumber: 1 | 2"
   *
   * @param setNumber {Number}
   */
  static builtInTypesSet(setNumber: BuiltInTypesSetNumber): Array<IObjectModelBuiltinPropertyDetail> {
    switch (setNumber) {
      /**
       * 1
       * Basic metadata for record transaction times, creator, and record holder basic info
       * Set is used in mapping builder "about record" feature
       */
      case 1:
        return [
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedBy],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.UpdatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderName],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderEmail],
        ]
      /**
       * 2
       * Use in model mapping values options when mapping is from object model to Salesforce
       * The key detail here is the "Formability ID", needed to link to an external ID field
       * in Salesforce to help prevent duplicate records from being created in Formability
       */
      case 2:
        return [
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedBy],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.UpdatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderName],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderEmail],
          {
            type: ObjectModelBuiltinPropertyType.RecordId,
            displayName: 'Formability ID',
            permissions: [AccessPermission.Read],
            propertyName: 'id',
            category: ObjectModelBuiltinCategory.FormabilityId,
            tooltip: 'Use this value to associate to an external ID field in an external connection such as Salesforce.'
          },
        ]
      /**
       * 3
       * Used with a "Match and create additional relationships (junctions) mapping rule
       * Used in List View -> Model Property -> "Property to Display"
       */
      case 3:
        return [
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.CreatedBy],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.UpdatedAt],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderName],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordHolderEmail],
          ObjectModelBuiltinPropertyDetails[ObjectModelBuiltinPropertyType.RecordId],
        ]
    }
  }

  static builtInValueType(type: ObjectModelBuiltinPropertyType): string {
    switch (type) {
      case ObjectModelBuiltinPropertyType.CreatedAt: // intentional fallthrough
      case ObjectModelBuiltinPropertyType.UpdatedAt:
        return `DateTime (readonly)`
      case ObjectModelBuiltinPropertyType.CreatedBy: // intentional fallthrough
      case ObjectModelBuiltinPropertyType.RecordHolderName:
      case ObjectModelBuiltinPropertyType.RecordHolderEmail:
        return `String (readonly)`
      case ObjectModelBuiltinPropertyType.RecordId:
        return `Id (readonly)`
      default:
        assertNever(type)
    }
  }

  static mappingValueOption(property: ObjectModelProperty): IDefaultVOption {
    return {
      label: property.label_title || `Untitled ${ObjectModelPropertyName(property)}`,
      value: property.client_id,
      labelSuffix: `(${ObjectModelPropertyName(property)})`
    }
  }

  static mappingValueBuiltInOption(enumVal: ObjectModelBuiltinPropertyType | string, builtInTypeSet: BuiltInTypesSetNumber = 1): IDefaultVOption {
    if (typeof enumVal === 'string') enumVal = parseInt(enumVal, 10);
    const detail = ObjectModelPropertyDefinition.builtInTypesSet(builtInTypeSet).find(d => d.type === enumVal)
    return {
      label: detail.displayName,
      value: detail.type,
      labelSuffix: ObjectModelPropertyDefinition.builtInValueType(enumVal),
    }
  }

  static linkedToRelationTypes(propertyType: ObjectModelPropertyType): ObjectModelRelationType[] {
    switch (propertyType) {
      case ObjectModelPropertyRootType.MappedProperty:
        // as parent, only one to one and many to one relations are mappable
        return [
          ObjectModelRelationType.OneToOne,
          ObjectModelRelationType.ManyToOne,
        ]
      case ObjectModelPropertyRootType.RelationshipCount:
      case ObjectModelPropertyRootType.Aggregate:
        // can always aggregate all types
        return EnumHelper.toArray(ObjectModelRelationType)
      default:
        return []
    }
  }

  static linkedToRelationInverseTypes(propertyType: ObjectModelPropertyType): ObjectModelRelationType[] {
    switch (propertyType) {
      case ObjectModelPropertyRootType.MappedProperty:
        // as child, only one to one and one to many relations are mappable
        return [
          ObjectModelRelationType.OneToOne,
          ObjectModelRelationType.OneToMany,
        ]
      case ObjectModelPropertyRootType.RelationshipCount:
      case ObjectModelPropertyRootType.Aggregate:
        // can always aggregate all types
        return EnumHelper.toArray(ObjectModelRelationType)
      default:
        return []
    }
  }

  static genericType(property: Pick<IObjectModelProperty, 'property_type' | 'mapped_property_type' | 'format_type'>): GenericType {
    switch (property.property_type) {
      case ObjectModelPropertyRootType.Text: // intentional fall-through
      case ObjectModelPropertyRootType.LongText: // intentional fall-through
      case ObjectModelPropertyRootType.PickList: // intentional fall-through
      case ObjectModelPropertyChildType.PickListOption: // intentional fall-through
        return ModelType.Text
      case ObjectModelPropertyRootType.DerivedField: // intentional fall-through
      case ObjectModelPropertyRootType.MappedProperty:
        if (property.mapped_property_type) {
          return ObjectModelPropertyDefinition.genericType({ property_type: property.mapped_property_type, format_type: property.format_type })
        } else {
          return ModelType.Text
        }
      case ObjectModelPropertyRootType.FileAttachment:
        return ModelType.File
      case ObjectModelPropertyRootType.Section:
        return ModelType.Object
      case ObjectModelPropertyRootType.DateTime:
        return ModelType.DateTime
      case ObjectModelPropertyRootType.Number:
        if (property.format_type === InputFormatType.Numeric) {
          return ModelType.Number
        } else {
          return ModelType.Text // this is InputFormatType.Currency
        }
      case ObjectModelPropertyRootType.RelationshipCount: // intentional fall-through
      case ObjectModelPropertyRootType.AutoIncrement: // intentional fall-through
      case ObjectModelPropertyRootType.Aggregate:
        return ModelType.Number
      default:
        assertNever(property.property_type)
    }
  }
}
